import { resolveComponent as _resolveComponent, createVNode as _createVNode, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, renderSlot as _renderSlot, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "gfu-media" }
const _hoisted_2 = { class: "gfu-media__body _pl-2" }
const _hoisted_3 = { class: "_flex _ai-c" }
const _hoisted_4 = ["data-qa"]
const _hoisted_5 = {
  class: "_tc--light gfu-bt--caption",
  "data-qa": "project-comment-header:date"
}
const _hoisted_6 = {
  key: 1,
  class: "gfu-comments-labels"
}
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { class: "_flex _ai-c" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_comment_user_avatar = _resolveComponent("comment-user-avatar")
  const _component_comment_user_profile = _resolveComponent("comment-user-profile")
  const _component_icon_base_label = _resolveComponent("icon-base-label")
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_tooltip = _resolveComponent("tooltip")
  const _component_comment_user_profile_actions = _resolveComponent("comment-user-profile-actions")
  const _component_project_comment_field = _resolveComponent("project-comment-field")
  const _component_project_comment_reply = _resolveComponent("project-comment-reply")
  const _component_project_comment_actions = _resolveComponent("project-comment-actions")
  const _component_like_action = _resolveComponent("like-action")

  return (_openBlock(), _createElementBlock("div", {
    ref: "scrollTarget",
    class: _normalizeClass(['gfu-comment-item', $options.elementClasses])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_comment_user_avatar, {
        author: $props.author,
        "is-breakpoint-large": $props.isBreakpointLarge
      }, null, 8 /* PROPS */, ["author", "is-breakpoint-large"]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", {
            class: "_flexwrap _ai-fe _col-gap-1",
            "data-qa": `project-comment-pinned:${$options.isPinned}`
          }, [
            _createVNode(_component_comment_user_profile, _mergeProps({author: $props.author, isGamefoundStaff: $options.isGamefoundStaff, isCreator: $options.isCreator}, {
              "is-breakpoint-large": $props.isBreakpointLarge,
              "data-qa": "project-comment-header:UserProfile"
            }), null, 16 /* FULL_PROPS */, ["is-breakpoint-large"]),
            ($options.isAuthorVerified)
              ? (_openBlock(), _createBlock(_component_icon_base_label, _mergeProps({ key: 0 }, $options.verifiedLabelModel, {
                  "data-qa": $options.verifiedLabelModel.dataQa
                }), null, 16 /* FULL_PROPS */, ["data-qa"]))
              : _createCommentVNode("v-if", true),
            _createElementVNode("span", _hoisted_5, _toDisplayString($options.commentDateText), 1 /* TEXT */),
            ($options.isEdited)
              ? (_openBlock(), _createBlock(_component_tooltip, {
                  key: 1,
                  text: $options.editedTooltipText,
                  class: "_lh-1"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_base_icon, {
                      name: "circle-info",
                      class: "_tc--light"
                    })
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["text"]))
              : _createCommentVNode("v-if", true)
          ], 8 /* PROPS */, _hoisted_4),
          ($options.isPinned)
            ? (_openBlock(), _createBlock(_component_base_icon, {
                key: 0,
                name: "thumbtack",
                class: "_ml-a"
              }))
            : _createCommentVNode("v-if", true)
        ]),
        ($options.hasUrlName)
          ? (_openBlock(), _createBlock(_component_comment_user_profile_actions, _normalizeProps(_mergeProps({ key: 0 }, {author: $props.author})), null, 16 /* FULL_PROPS */))
          : _createCommentVNode("v-if", true),
        ($options.hasLabel)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.userLabels, (label) => {
                return (_openBlock(), _createBlock(_component_icon_base_label, _mergeProps({
                  key: label.name
                }, { ref_for: true }, label, {
                  "data-qa": label.dataQa
                }), null, 16 /* FULL_PROPS */, ["data-qa"]))
              }), 128 /* KEYED_FRAGMENT */))
            ]))
          : _createCommentVNode("v-if", true),
        (_ctx.isEditing)
          ? (_openBlock(), _createBlock(_component_project_comment_field, {
              key: 2,
              ref: "edit",
              mode: "edit",
              class: "_mt-3",
              message: $props.text,
              onSubmit: $options.onEditSubmit,
              onCancel: $options.onCancel
            }, null, 8 /* PROPS */, ["message", "onSubmit", "onCancel"]))
          : (_openBlock(), _createElementBlock("div", {
              key: 3,
              ref: "content",
              class: "gfu-comment-item__content",
              onClick: _cache[0] || (_cache[0] = (...args) => ($options.onContentClick && $options.onContentClick(...args))),
              innerHTML: $options.formattedText,
              "data-qa": "project-comment-content"
            }, null, 8 /* PROPS */, _hoisted_7)),
        _createElementVNode("div", _hoisted_8, [
          ($options.isProjectCommentReplyVisible)
            ? (_openBlock(), _createBlock(_component_project_comment_reply, {
                key: 0,
                class: "_mr-1",
                "can-comment": $props.canComment,
                onReply: _cache[1] || (_cache[1] = $event => (_ctx.$emit('reply', { commentThreadID: $props.commentThreadID, commentID: $props.commentID })))
              }, null, 8 /* PROPS */, ["can-comment"]))
            : _createCommentVNode("v-if", true),
          ($options.isUserAuthenticated)
            ? (_openBlock(), _createBlock(_component_project_comment_actions, _mergeProps({
                key: 1,
                "comment-thread-i-d": $props.commentThreadID,
                "comment-i-d": $props.commentID,
                "parent-i-d": $props.parentID,
                "pinned-at": $props.pinnedAt,
                "has-children": $props.hasChildren,
                hidden: $options.hidden,
                "is-editing": _ctx.isEditing,
                "has-pin-comment-action": $props.hasPinCommentAction,
                "has-report-and-hide-action": $props.hasReportAndHideAction,
                "is-own-comment": $options.isOwnComment,
                "can-comment": $props.canComment,
                "is-reported-by-creator": $props.isReportedByCreator,
                "allow-creator-hiding-comments": $props.allowCreatorHidingComments,
                "has-user-admin-url": $options.hasUserAdminUrl,
                "admin-url": $props.author.adminUrl,
                class: "_mr-1"
              }, $setup.listeners, {
                onEdit: $options.onToggleEdit,
                "data-qa": `project-comment-hidden:${$options.hidden}`
              }), null, 16 /* FULL_PROPS */, ["comment-thread-i-d", "comment-i-d", "parent-i-d", "pinned-at", "has-children", "hidden", "is-editing", "has-pin-comment-action", "has-report-and-hide-action", "is-own-comment", "can-comment", "is-reported-by-creator", "allow-creator-hiding-comments", "has-user-admin-url", "admin-url", "onEdit", "data-qa"]))
            : _createCommentVNode("v-if", true),
          (!$options.hidden)
            ? (_openBlock(), _createBlock(_component_like_action, {
                key: 2,
                "likes-count": $props.likesCount,
                "is-liked": $options.isLiked,
                enabled: $options.isUserAuthenticated,
                onLike: _cache[2] || (_cache[2] = $event => (_ctx.$emit('like', { commentID: $props.commentID }))),
                "data-qa": `project-comment-liked:${$options.isLiked}`
              }, null, 8 /* PROPS */, ["likes-count", "is-liked", "enabled", "data-qa"]))
            : _createCommentVNode("v-if", true)
        ]),
        _renderSlot(_ctx.$slots, "default")
      ])
    ])
  ], 2 /* CLASS */))
}